/**
 * Type definitions for assets exported in website FLibs
 * @typedef {Object} AssetsExport
 * @property {string} logo
 * @property {string} logo_light
 */

/**
 * @typedef {Object} SaveToPortfolio
 * @property {() => Promise<{ SaveToPortfolio: React.ComponentType<any> }>} importFn
 * @property {string} cacheKey
 */

/**
 * @typedef {Object} CreateAlert
 * @property {() => Promise<{ CreateAlert: React.ComponentType<any> }>} importFn
 * @property {string} cacheKey

/**
 * @typedef {Object} PortfolioWatchlistTable
 * @property {() => Promise<{ PortfolioWatchlistTable: React.ComponentType<any> }>} importFn
 * @property {string} cacheKey
 */

/**
 * @typedef {Object} LocalStorageService
 * @property {<ValueType>(key: string, defaultValue: ValueType) => ValueType} getValue
 * @property {<ValueType>(key: string, valueGetter: React.SetStateAction<ValueType>, defaultValue: ValueType, emit?: boolean) => void} setValue
 * @property {(key: string, emit?: boolean) => void} removeValue
 * @property {<PrevValue, NewValue>(key: string, transformValue: NewValue | ((oldValue: PrevValue | NewValue) => NewValue), defaultValue: NewValue) => void} migrateValue
 */

/**
 * Type definitions for functions exported in website FLibs
 * @typedef {Object} FLibsExport
 * @property {AssetsExport} assets
 * @property {(date?: Date, format?: TimeFormatType) => string} getFormattedDateString
 * @property {(date: Date) => string} formatDateToStringUS
 * @property {<ValueType>(key: string, defaultValue: ValueType) => ({ state: ValueType, setState: (value: React.SetStateAction<ValueType>) => void })} useSyncLocalStorage
 * @property {(props: { trackInitial?: boolean; trackAutomatically?: boolean; }) => () => void} useTrackPageView
 * @property {SaveToPortfolio} saveToPortfolioAsyncModule
 * @property {CreateAlert} createAlertAsyncModule
 * @property {PortfolioWatchlistTable} portfolioWatchlistTableAsyncModule
 * @property {LocalStorageService} localStorage
 * @property {<ValueType = unknown>(importFn: () => Promise<ValueType>, retries = 0) => Promise<ValueType>} importWithRetry
 * @property {<P extends Record<string, any>>(Component: React.ComponentType<P>, fallback?: React.ReactNode) => ((props: P) => JSX.Element)} withSuspense
 * @property {(callback: (visible: boolean, isFetching: boolean) => void | Promise<void>) => { callback: () => Promise<void>; unsubscribe: () => void }} notifyOnVisibilityChange
 * @property {(interval: number | (() => number), callback: () => void | Promise<void>) => () => void} intervalCallbackOnWindowVisible
 * @property {(callback: () => void | Promise<void>) => () => Promise<void>} waitForPreviousPromise
 */

/**
 * Add type so that the properties are suggested
 * @type {FLibsExport}
 */
const FLibsExports = typeof window === 'undefined' ? {} : window.FLibs

module.exports = FLibsExports
